module.exports = __webpack_public_path__ + "static/media/12.b61e37f9.jpg";